import * as React from 'react'
import Tick from '../_Assets/vendor/flipclock'

import './Flipclock.scss'

interface FlipclockProps {
  show: boolean
  timestamp: string | Date
  locale?: { [key: string]: string }
  // Must be in form: y, M, d, h, m, s
  format?: string
  hideLabel?: boolean

  onTick?(value: number): void
  onZero?(): void
}

class Flipclock extends React.Component<FlipclockProps, {}> {
  constructor(props: FlipclockProps) {
    super(props)
  }

  public componentDidMount() {
    if (this.props.show) {
      this.startTick()
    }
  }

  public componentDidUpdate() {
    if (this.props.show) {
      this.startTick()
    } else {
      this.stopTick()
    }
  }

  public componentWillUnmount() {
    this.stopTick()
  }

  public render() {
    return this.props.show ? (
      <div className="srprs-flipclock" ref="counter">
        <div
          data-layout="horizontal center fit"
          data-repeat="true"
          data-transform={`preset(${this.getFormat()}) -> delay`}
        >
          <div className="tick-group">
            <div
              data-key="value"
              data-repeat="true"
              data-transform="pad(00) -> split -> delay"
            >
              <span data-view="flip" />
            </div>
            {this.props.hideLabel ? null : (
              <span className="tick-label" data-key="label" data-view="text" />
            )}
          </div>
        </div>
      </div>
    ) : null
  }

  private getFormat = () => {
    return this.props.format || 'd, h, m, s'
  }

  private startTick = () => {
    const format = this.getFormat().split(', ')
    Tick.DOM.create(this.refs.counter, {
      didInit: (tick: any) => {
        const countdown = Tick.count.down(this.props.timestamp, { format })
        countdown.onupdate = (value: number) => {
          tick.value = value
          if (this.props.onTick) {
            this.props.onTick(value)
          }
        }
        if (this.props.onZero) {
          countdown.onended = this.props.onZero
        }

        Object.entries(this.props.locale || {}).forEach(([key, entry]) => {
          tick.setConstant(key, entry)
        })
      },
    })
  }

  private stopTick = () => {
    if (this.refs.counter) {
      Tick.DOM.destroy(this.refs.counter)
    }
  }
}

export default Flipclock
